import axios from 'axios';

/**
 * Submits form data to Web3Forms.
 * 
 * @param {Object} data - The form data to submit.
 * @param {Object} options - Metadata for the submission.
 * @param {string} options.formName - A identifier for the form.
 * @param {string} options.subject - The subject line for the email notification.
 * @returns {Promise<Object>} - The response from Web3Forms.
 */
export const submitToWeb3Forms = async (data, { formName, subject }) => {
    const accessKey = 'b94eb0e9-3bce-4e8c-b978-db2e1131fc6c';
    const pageUrl = window.location.href;

    const payload = {
        access_key: accessKey,
        from_name: 'STEM Education Trust Website',
        subject: subject || `New Submission: ${formName}`,
        form_name: formName,
        page_url: pageUrl,
        ...data
    };

    try {
        const response = await axios.post('https://api.web3forms.com/submit', payload);
        return response.data;
    } catch (error) {
        console.error('Web3Forms Submission Error:', error);
        throw error;
    }
};
